import React, { useEffect, useState } from 'react';
import axios from 'axios';
import regresaFecha from '../tools/regresaBienFechayDia';
import { Accordion, Card, Button } from 'react-bootstrap';

const ParteList = ({ enviar }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.post('https://wwwa.isepsantafe.net.ar/expedientes/partes');
        // Ordenamos los archivos de más nuevo a más viejo
//         console.log(response)
        const sortedFiles = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setFiles(sortedFiles);
      } catch (err) {
        setError('Error al cargar los archivos');
      } finally {
        setLoading(false);
      }
    };
    
    fetchFiles();
  }, [enviar]);

  if (loading) return <p>Cargando archivos...</p>;
  if (error) return <p>{error}</p>;

  // Obtener la fecha de hoy en formato YYYY-MM-DD
  const today = new Date().toLocaleDateString("es-AR", {
    timeZone: "America/Argentina/Buenos_Aires",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .split("/")
    .reverse()
    .join("-");
  
//   console.log(today); // Ejemplo: "2024-04-01"
  

  // Filtrar el parte de hoy y los anteriores
  const parteHoy = files.find(file => file.createdAt.startsWith(today));
  const partesAnteriores = files.filter(file => !file.createdAt.startsWith(today));

  return (
  <>
  <div style={{display:"flex",flexDirection:"column",width:"90%",alignItems:"center", border:"3px #ddd solid",margin:"10px"}}> 
<h2>Partes Diario</h2>
  <div style={{maxWidth:"400px",alignItems:"center", margin:"5px",textAlign:"center"}} >
  <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Parte de Hoy</Accordion.Header>
        <Accordion.Body>
          {parteHoy ? (
            <a 
              href={`https://wwwa.isepsantafe.net.ar/partes/${parteHoy.name}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-primary"
            >
              Ver Parte de Hoy
            </a>
          ) : (
            <p>No hay parte disponible para hoy.</p>
          )}
        </Accordion.Body>
      </Accordion.Item>
      
      <Accordion.Item eventKey="1">
        <Accordion.Header>Partes Anteriores</Accordion.Header>
        <Accordion.Body>
        <div style={{maxHeight:"500px",overflow:"auto"}}>
                
              
          {partesAnteriores.length > 0 ? (
            <ul>
              {partesAnteriores.map((file) => (
                <li key={file.name}>
                  <a href={`https://wwwa.isepsantafe.net.ar/partes/${file.name}`} target="_blank" rel="noopener noreferrer">
                    {regresaFecha(file.createdAt)}
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <p>No hay partes anteriores disponibles.</p>
          )}  </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  </div>

    
    </div>
    </>)
};

export default ParteList;
